import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox, TextBoxProps } from "../core/components/textBox";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { ColumnInfo, IndividualField, SelectionType } from "./editField";
import { Helper } from "../core/util/helper";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class EditLookpUpTable extends React.Component<EditLookpUpTableProps, EditLookpUpTableState> {
    private factory = ComponentHelper.createFactory();
    private textBoxProps: TextBoxProps;
    private translations: StringKeyDictionary<string>;
    private isInit: boolean;
    constructor(props: EditLookpUpTableProps) {
        super(props);
        this.translations = props.context.translations;
        this.state = {
            value: "",
            columns: []
        }
        this.initApp();
    }

    private setValue = async (value: string) => {
        const result = await HTTPService.get<JsonResultClass<ColumnInfo[]>>(`EditIndividualFields/GetAllColumns?tableName=${value}`);
        let data = [];
        if (result.Code == 0) {
            data = result.Data;
        }
        this.setState({ value: value, columns: data }, () => {
            this.props.onChange(this.props.field, value, { columns: data }, this.isInit);
            this.isInit = false;
        })
    }

    private initApp = () => {
        this.isInit = true;
        this.textBoxProps = this.factory.getDefaultTextBoxProps();
        this.textBoxProps.field = this.props.field;
        this.textBoxProps.onChange = (_, value: string) => {
            this.setValue(value);
        }
        this.setValue(this.props.value);
    }

    private createTextBox = () => {
        return <TextBox {...this.textBoxProps} value={this.state.value} />
    }

    private createInfo = () => {
        let renderIcon = false;
        let text = "";
        if (!Helper.isNullOrEmpty(this.state.value)) {
            if (this.state.columns.length == 0) {
                renderIcon = true;
                text = this.translations["WebCRM.EditIndividualCategories.TableDoesNotExists"].replace("{table}", this.state.value);
            } else if (!this.areColumnsOk()) {
                renderIcon = true;
                let cols = this.getMissingColumns();
                cols = cols.map((value) => { return `"${value}"` });
                text = this.translations["WebCRM.EditIndividualCategories.ColumnsAreMissing"].replace("{list}", cols.join(", "));
            }
        }
        if (renderIcon) {
            return (
                <div style={{margin: "5px 0", display: "flex", alignItems: "center"}}>
                    <i className={`fal fa-exclamation-triangle fa-2x`} style={{ color: "red" }}></i>
                    <label style={{ marginLeft: "10px" }}>{text}</label>
                </div>
            );
        } else {
            return null;
        }
    }

    private areColumnsOk = () => {
        let result = true;
        const checkIfColumnExits = (name: string) => {
            let col = this.state.columns.find(f => f.ColumnName.toLowerCase() == name.toLowerCase());
            result &&= Helper.hasValue(col);
        }
        checkIfColumnExits("bezeichnung");
        checkIfColumnExits("nr");
        if (this.props.entity.SelectionType == SelectionType.MultiLangDropDownList) {
            checkIfColumnExits("language");
        }
        return result;
    }

    private getMissingColumns = () => {
        let lst = [];
        const addIfColumnNotExits = (name: string) => {
            let col = this.state.columns.find(f => f.ColumnName.toLowerCase() == name.toLowerCase());
            if (!Helper.hasValue(col))
                lst.push(name);
        }
        addIfColumnNotExits("Nr");
        addIfColumnNotExits("Bezeichnung");
        if (this.props.entity.SelectionType == SelectionType.MultiLangDropDownList) {
            addIfColumnNotExits("Language");
        }
        return lst;
    }

    render() {
        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                {this.createTextBox()}
                {this.createInfo()}
            </div>
        );
    }

}

interface EditLookpUpTableProps{
    value: string;
    field: any;
    onChange?(field: { model: string }, value: string, dataItem: any, isInit: boolean);
    entity: IndividualField;
    context: any;
}

interface EditLookpUpTableState {
    value: string;
    columns: ColumnInfo[];
}